import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '爱漫画网',
  url: 'https://aimanhua.example.com',
  description:
    '爱漫画网提供下拉式漫画阅读、翻页漫画、无弹窗漫画等多种阅读模式，支持漫画全屏观看。告别广告干扰，沉浸式追漫体验让免费看漫画全集更流畅。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://aimanhua.example.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />

      <Header />

      <main>
        <Hero />
        <UpdatesSection />
        <ContactSection />
        <AboutSection />
        <FaqSection />
        <AppSection />
        <IndexSection />
        <CardsSection />
        <RankingSection />
        <FeaturesSection />
        <MediaSection />
        <TopicsSection />
        <CommentsSection />
        <CarouselSection />
      </main>

      <Footer />
    </>
  );
}